import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { OtpResendPayload, OtpResendResponse } from '@repo/user-types'

const initialState: GenericOperationState<OtpResendResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: otpResendActions, reducer: otpResendReducer } = createOperationSlice<
  OtpResendResponse | null,
  SliceCaseReducers<GenericOperationState<OtpResendResponse | null>>,
  OtpResendPayload
>({
  name: '@users/otp/resend',
  initialState,
  reducers: {},
})
